import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUbereatsComponent } from './simple-icons-ubereats.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUbereatsComponent ],
    exports:      [ SimpleIconsUbereatsComponent ],
    bootstrap:    []
})
export class SimpleIconsUbereatsModule {}
